import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IntegrationsCatalogDetails from "./routes/IntegrationsCatalogDetails";
import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "catalog",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        return component;
      })
    // .catch(err => {
    //   console.log(err);
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("INTEGRATIONS_CATALOG"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [IntegrationsCatalogDetails(store)],
});
